export const getCurrentLocaleSelector = state => state.locale.get('current')
